export const palacioImages = {
  heroScreens: {
    src: 'https://cdn.magicpatterns.com/uploads/5E6p5uaDZdzNwNpTDJ4BRU/image_(3).avif',
    alt: 'Four Palacio app screens: Login with the Tarjeta Palacio campaign, Card Details with available balance, Statement with balance and payment details, and Pay Your Card with payment options',
  },
  benchmark: {
    src: 'https://cdn.magicpatterns.com/uploads/ghpph2rYXfVy3S676Hf2EH/image_(5).avif',
    alt: 'Competitor and benchmark review slides for Liverpool, Mercado Libre, Chanel, Louis Vuitton, American Express and Rappi, each with guiding questions beside app screenshots',
  },
  personas: {
    src: 'https://cdn.magicpatterns.com/uploads/ci5Lgap34HBQyEAPkDj4Q5/image_(4).avif',
    alt: 'Four persona sheets: Valeria “The Fashionista”, Maria “The Icon”, Angelo “The Ripper” and the Garcia family “The Family”, each with personality sliders, bio, goals and frustrations',
  },
  wireframes: {
    src: 'https://cdn.magicpatterns.com/uploads/mV93T3HUWfchZcGjo4sEA6/image_(6).avif',
    alt: 'Annotated wireframes with stakeholder comments: a product detail page with open questions, and the Tarjeta and Saldo credit screens with sticky notes on the details to show',
  },
};

/** Snapshots from the store visits, shown as polaroids at the end of the case study. */
export const palacioFieldPolaroids = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/xe4r42aKTDRkZR8eSoYL6e/image.png',
    alt: 'In-store credit kiosk showing the Palacio, Socio and Total card tiers',
    caption: 'The only place to check your card',
    tilt: -4,
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4we7gBNXnk2FdfQdWL4CSi/image.png',
    alt: 'Point-of-sale setup at a store counter: two touchscreen terminals, receipt printers and card readers',
    caption: 'Behind the counter',
    tilt: 3,
  },
];

/** In-store immersion photos. */
export const palacioStorePhotos = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/qJF4Uw6A2huaX6fbP9yFvu/IMG_5626.heic',
    alt: 'Kat outside a Palacio de Hierro store at night',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gtUAWT4V3RLzcxfoJmemG2/IMG_5619_2.heic',
    alt: 'In-store credit kiosk showing the three Palacio card tiers',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qyRtAhVQkfPNSTSTQpLrFJ/IMG_5618_2.heic',
    alt: 'In-store credit kiosk home screen, with a printed guide to checking your statement online',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wS5RqrauaXerpDCjRHcR1t/IMG_5613.heic',
    alt: 'Mirror selfie in a Palacio de Hierro fitting room during the store tour',
  },
];
